import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Page Cours d'essai (19,98 $) — POC Phase 6
 * URL : /plateforme/essai-gratuit
 * Formulaire de capture de leads — convertit le visiteur en prospect.
 */
export default function PlateformeEssai() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    discipline: "non-decide",
    experience: "debutant",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Cours d'essai (19,98 $) — Institut Impact Élite";
    const linkPreconn = document.createElement("link");
    linkPreconn.rel = "preconnect";
    linkPreconn.href = "https://fonts.googleapis.com";
    document.head.appendChild(linkPreconn);
    const linkFonts = document.createElement("link");
    linkFonts.rel = "stylesheet";
    linkFonts.href =
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Inter:wght@300;400;500;700&display=swap";
    document.head.appendChild(linkFonts);
    return () => {
      document.head.removeChild(linkPreconn);
      document.head.removeChild(linkFonts);
    };
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await axios.post(`${BACKEND}/api/plateforme/trial-leads`, form);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur — réessaie ou contacte-nous directement à sdm.rdjp@gmail.com");
    } finally {
      setSubmitting(false);
    }
  };

  const baseStyle = {
    fontFamily: "Inter, system-ui, sans-serif",
    background: "#0d0d0d",
    color: "#f5f5f5",
    minHeight: "100vh",
  };

  return (
    <div style={baseStyle} data-testid="plateforme-essai">
      <style>{`
        .editorial { font-family: 'Playfair Display', serif; }
        .label { letter-spacing: 0.4em; font-size: 11px; }
        .frame { border: 1px solid rgba(201, 169, 97, 0.25); }
        .divider-gold { background: linear-gradient(90deg, transparent, #C9A961 30%, #C9A961 70%, transparent); height: 1px; }
        .gold { color: #C9A961; }
        .red-c { color: #C8102E; }
        .bg-red-c { background: #C8102E; }
        .bg-gold { background: #C9A961; }
        .btn-primary { background: #C8102E; color: #fff; transition: 0.3s; border: none; cursor: pointer; }
        .btn-primary:hover { background: #fff; color: #C8102E; }
        .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
        .btn-secondary { color: #C9A961; border: 1px solid #C9A961; transition: 0.3s; background: transparent; }
        .btn-secondary:hover { background: #C9A961; color: #0d0d0d; }
        .pf-link { transition: color 0.2s; }
        .pf-link:hover { color: #C9A961; }
        .input-pf {
          background: #161616;
          border: 1px solid rgba(201, 169, 97, 0.25);
          color: #f5f5f5;
          padding: 14px 18px;
          width: 100%;
          font-family: 'Inter', sans-serif;
          font-size: 15px;
          transition: border 0.2s;
        }
        .input-pf:focus { border-color: #C9A961; outline: none; }
        .input-pf::placeholder { color: rgba(255, 255, 255, 0.3); }
        select.input-pf option { background: #161616; }
      `}</style>

      {/* === NAV === */}
      <nav className="px-10 py-6 flex items-center justify-between" style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
        <Link to="/plateforme" className="flex items-center gap-4">
          <div className="relative">
            <div className="w-12 h-12 bg-red-c flex items-center justify-center">
              <span className="editorial text-white text-2xl font-black">I</span>
            </div>
            <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-gold"></div>
          </div>
          <div>
            <div className="label gold">— INSTITUT —</div>
            <div className="editorial text-2xl font-bold leading-none mt-0.5">Impact Élite</div>
          </div>
        </Link>
        <Link to="/plateforme" className="pf-link text-sm">← Retour</Link>
      </nav>

      <section className="grid md:grid-cols-12 min-h-[calc(100vh-90px)]">
        {/* === LEFT — narratif === */}
        <div className="md:col-span-5 px-10 py-16 flex flex-col justify-center" style={{ background: "#161616" }}>
          <div className="label red-c mb-8">— OFFRE FONDATEUR —</div>
          <h1 className="editorial font-black text-5xl md:text-6xl leading-[0.95] mb-10" data-testid="essai-title">
            Un cours.<br />
            <span className="italic gold">19,98 $.</span><br />
            Sans engagement.
          </h1>
          <div className="divider-gold w-32 mb-8"></div>
          <p className="editorial italic text-xl text-white/80 mb-10 leading-relaxed">
            « Avant de t'engager, viens voir comment je travaille. Comment je transmets. Comment ça se passe. Tu décideras après. »
          </p>
          <div className="space-y-4 text-sm text-white/75">
            <div className="flex gap-3"><span className="gold">◆</span><span>Cours d'essai en présentiel à Val-d'Or OU session découverte en ligne (Plateforme Formation)</span></div>
            <div className="flex gap-3"><span className="gold">◆</span><span>Aucune carte de crédit · aucune obligation</span></div>
            <div className="flex gap-3"><span className="gold">◆</span><span>1h dédiée pour évaluer ton niveau et ton objectif</span></div>
            <div className="flex gap-3"><span className="gold">◆</span><span>Recommandation personnalisée du cycle qui te convient (PCO/PCN/Master)</span></div>
          </div>
          <div className="mt-12 pt-8 border-t border-white/10">
            <div className="label gold mb-3">— RÉPONSE GARANTIE —</div>
            <div className="text-sm text-white/60">Nous te répondons en moins de 24h ouvrables. Souvent le même jour.</div>
          </div>
        </div>

        {/* === RIGHT — formulaire === */}
        <div className="md:col-span-7 px-10 py-16 flex flex-col justify-center">
          <div className="max-w-xl w-full">
            {!submitted ? (
              <>
                <div className="label red-c mb-6">— RÉSERVE TON CRÉNEAU —</div>
                <h2 className="editorial font-black text-3xl md:text-4xl mb-3">
                  Une minute pour <span className="italic gold">commencer</span>.
                </h2>
                <p className="text-white/60 mb-12 text-sm">Remplis ce qui suit, on revient vers toi rapidement avec les disponibilités.</p>

                <form onSubmit={handleSubmit} className="space-y-6" data-testid="essai-form">
                  <div>
                    <label className="label gold block mb-2">— NOM COMPLET —</label>
                    <input
                      type="text" name="name" required minLength={2}
                      value={form.name} onChange={handleChange}
                      className="input-pf"
                      placeholder="Jean Tremblay"
                      data-testid="input-name"
                    />
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="label gold block mb-2">— COURRIEL —</label>
                      <input
                        type="email" name="email" required
                        value={form.email} onChange={handleChange}
                        className="input-pf"
                        placeholder="ton@courriel.com"
                        data-testid="input-email"
                      />
                    </div>
                    <div>
                      <label className="label gold block mb-2">— TÉLÉPHONE (OPT.) —</label>
                      <input
                        type="tel" name="phone"
                        value={form.phone} onChange={handleChange}
                        className="input-pf"
                        placeholder="819 555-1234"
                        data-testid="input-phone"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="label gold block mb-2">— DISCIPLINE D'INTÉRÊT —</label>
                    <select name="discipline" value={form.discipline} onChange={handleChange} className="input-pf" data-testid="select-discipline">
                      <option value="non-decide">Pas encore décidé · à discuter</option>
                      <option value="kickboxing">Kickboxing / Muay Thaï</option>
                      <option value="jiu-jitsu-japonais">Jiu-Jitsu Can Ryu</option>
                      <option value="jiu-jitsu-bresilien">Jiu-Jitsu Brésilien</option>
                      <option value="petits-samourais">Petits Samouraïs (3-6 ans)</option>
                    </select>
                  </div>

                  <div>
                    <label className="label gold block mb-2">— EXPÉRIENCE —</label>
                    <select name="experience" value={form.experience} onChange={handleChange} className="input-pf" data-testid="select-experience">
                      <option value="debutant">Débutant · jamais pratiqué</option>
                      <option value="intermediaire">Intermédiaire · quelques années</option>
                      <option value="experimente">Expérimenté · plusieurs années</option>
                    </select>
                  </div>

                  <div>
                    <label className="label gold block mb-2">— MESSAGE (OPT.) —</label>
                    <textarea
                      name="message" rows={3}
                      value={form.message} onChange={handleChange}
                      className="input-pf"
                      placeholder="Ton objectif, ce que tu cherches, tes contraintes d'horaire..."
                      maxLength={500}
                      data-testid="input-message"
                    />
                  </div>

                  {error && (
                    <div className="frame p-4 text-sm text-red-300" style={{ background: "#3b0d0d", borderColor: "#C8102E" }} data-testid="essai-error">
                      ⚠️ {error}
                    </div>
                  )}

                  <button type="submit" disabled={submitting}
                    className="btn-primary w-full py-4 font-bold tracking-[0.3em] text-xs"
                    data-testid="essai-submit">
                    {submitting ? "ENVOI EN COURS..." : "RÉSERVER MON ESSAI →"}
                  </button>
                  <div className="text-[10px] text-white/30 tracking-widest text-center mt-4">
                    EN SOUMETTANT, TU ACCEPTES NOTRE POLITIQUE DE CONFIDENTIALITÉ (LOI 25 · QUÉBEC).
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center py-12" data-testid="essai-success">
                <div className="text-7xl mb-8">🥋</div>
                <div className="label gold mb-4">— C'EST DANS LA POCHE —</div>
                <h2 className="editorial font-black text-4xl md:text-5xl mb-6">
                  Ton créneau<br /><span className="italic gold">est réservé</span>.
                </h2>
                <p className="text-white/70 max-w-md mx-auto mb-10 leading-relaxed">
                  Merci {form.name.split(" ")[0]}. Nous te répondons à <span className="gold">{form.email}</span> sous 24h ouvrables avec les disponibilités et les détails pratiques.
                </p>
                <div className="divider-gold w-32 mx-auto mb-10"></div>
                <p className="text-sm text-white/50 mb-8">En attendant, explore le reste de l'Institut :</p>
                <div className="flex flex-wrap justify-center gap-3">
                  <Link to="/plateforme/disciplines/kickboxing" className="btn-secondary px-6 py-3 text-xs tracking-[0.2em]">
                    DÉCOUVRIR LE KICKBOXING
                  </Link>
                  <Link to="/plateforme/fondateur" className="btn-secondary px-6 py-3 text-xs tracking-[0.2em]">
                    LE FONDATEUR
                  </Link>
                  <Link to="/plateforme/temoignages" className="btn-secondary px-6 py-3 text-xs tracking-[0.2em]">
                    LES TÉMOIGNAGES
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <footer className="px-10 py-12" style={{ borderTop: "1px solid rgba(201,169,97,0.2)" }}>
        <div className="max-w-6xl mx-auto text-center">
          <div className="editorial font-black text-2xl mb-2">Institut Impact Élite</div>
          <div className="text-sm text-white/60 mb-6">Val-d'Or, Québec, Canada · sdm.rdjp@gmail.com</div>
          <div className="divider-gold w-32 mx-auto mb-4"></div>
          <div className="text-xs text-white/40 tracking-widest">© 2026 — POC PHASE 6 · cours d'essai (19,98 $)</div>
        </div>
      </footer>
    </div>
  );
}
